import { InputMaybe, Visitor, VisitorGroup } from 'graphql/generated/graphqlTypes';
import { externalUsersGroupsVar } from 'state/vars';

export const setExternalUsersGroupsAction = (groups: VisitorGroup[]) => {
  externalUsersGroupsVar(groups);
};

export const addExternalUsersGroupsAction = (addedGroup: VisitorGroup) => {
  const currentGroups = externalUsersGroupsVar();
  externalUsersGroupsVar([...currentGroups, addedGroup]);
};

export const updateExternalUsersGroupsAction = (updatedGroup: VisitorGroup) => {
  const currentGroups = externalUsersGroupsVar();
  const updatedGroups = currentGroups.map((group) => {
    if (group.id === updatedGroup.id) {
      return updatedGroup;
    }
    return group;
  });
  externalUsersGroupsVar(updatedGroups);
};

export const addExternalUsersMemberAction = (member: Visitor, visitorGroupId: string) => {
  const currentGroups = externalUsersGroupsVar();
  const updatedGroups = currentGroups.map((group) => {
    if (group.id === visitorGroupId) {
      return { ...group, members: [...group.members, member] };
    }
    return group;
  });
  externalUsersGroupsVar(updatedGroups);
};

export const deleteVisitorGroupByIdAction = (visitorGroupId: string | null) => {
  const currentGroups = externalUsersGroupsVar();
  const updatedGroups = currentGroups.filter((group) => group.id !== visitorGroupId);
  externalUsersGroupsVar(updatedGroups);
};

export const setExternalUsersMemberAction = (
  updatedMember: Visitor,
  visitorGroupIds: (InputMaybe<string> | undefined)[]
) => {
  const currentGroups = externalUsersGroupsVar();
  const updatedGroups = currentGroups.map((group) => {
    if (group.id === visitorGroupIds[0])
      if (group.members.some((member) => member.id === updatedMember.id))
        return {
          ...group,
          members: group.members.map((member) => (member.id === updatedMember.id ? updatedMember : member))
        };
      else
        return {
          ...group,
          members: [...group.members, updatedMember]
        };
    return {
      ...group,
      members: group.members.filter((member) => member.id !== updatedMember.id)
    };
  });
  externalUsersGroupsVar(updatedGroups);
};

export const deleteVisitorByIdAction = (visitorId: string | null) => {
  const currentGroups = externalUsersGroupsVar();

  const groupWithDeletedMember = currentGroups.filter((group) =>
    group.members.some((member) => member.id === visitorId)
  )[0];

  const updatedGroups = currentGroups.map((group) => {
    if (group.id === groupWithDeletedMember.id)
      return {
        ...group,
        members: group.members.filter((member) => member.id !== visitorId)
      };
    return group;
  });

  externalUsersGroupsVar(updatedGroups);
};

export const disconnectMobileDeviceAction = (visitorId: string, mobileDeviceId: string) => {
  const currentGroups = externalUsersGroupsVar();

  const groupWithDeletedMember = currentGroups.filter((group) =>
    group.members.some((member) => member.id === visitorId)
  )[0];

  const memberToDelete = groupWithDeletedMember.members.find((member) => member.id === visitorId);
  const updatedMember = {
    ...memberToDelete,
    mobileDevices: memberToDelete?.mobileDevices.map((mobileDevice) =>
      mobileDevice.id === mobileDeviceId
        ? { ...mobileDevice, isRegistered: false, registrationDate: null, registrationToken: null }
        : mobileDevice
    )
  } as Visitor;
  const updatedGroups = currentGroups.map((group) => {
    if (group.id === groupWithDeletedMember.id)
      return {
        ...group,
        members: group.members.map((member) => (member.id === visitorId ? updatedMember : member))
      };
    return group;
  });

  externalUsersGroupsVar(updatedGroups);
};
